import { createAction, ActionsUnion } from 'app/shared/utils/action-helpers';

// Models
import { DropdownActionTypes } from 'app/shared/dropdown/models';
import { PaginatedAgentsPayload } from 'app/modules/agents/requests';
import { PaginatedAgentsResponse } from 'app/modules/agents/responses';

export const retrieveDropdownAgents = (payload: PaginatedAgentsPayload) => {
  return createAction(DropdownActionTypes.RETRIEVE_DROPDOWN_AGENTS, payload);
};

export const retrieveDropdownAgentsSuccess = (
  result: PaginatedAgentsResponse,
) => {
  return createAction(
    DropdownActionTypes.RETRIEVE_DROPDOWN_AGENTS_SUCCESS,
    result,
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ReduxActionsList = {
  retrieveDropdownAgents,
  retrieveDropdownAgentsSuccess,
};

type ReduxActions = ActionsUnion<typeof ReduxActionsList>;
export default ReduxActions;
